import React from 'react';
import Chart from "react-apexcharts";
import { FiEdit } from 'react-icons/fi';
import { MdDeleteForever } from 'react-icons/md';
import { useSelector } from 'react-redux';


const RedialChartLayout = ({ data, mode, handlerRemove, handlerUpdate }) => {
    const { userDetails } = useSelector((state) => state.user);
    // const value = data.value * data.
    var options = {
        series: [76],
        options: {
            chart: {
                type: 'radialBar',
                offsetY: -20,
                sparkline: {
                    enabled: true
                }
            },
            plotOptions: {
                radialBar: {
                    startAngle: -90,
                    endAngle: 90,
                    track: {
                        background: "#e7e7e7",
                        strokeWidth: '97%',
                        margin: 5, // margin is in pixels
                        dropShadow: {
                            enabled: true,
                            top: 2,
                            left: 0,
                            color: '#999',
                            opacity: 1,
                            blur: 2
                        }
                    },
                    dataLabels: {
                        name: {
                            show: false
                        },
                        value: {
                            offsetY: -2,
                            fontSize: '22px'
                        }
                    }
                }
            },
            grid: {
                padding: {
                    top: -10
                }
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'light',
                    shadeIntensity: 0.4,
                    inverseColors: false,
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 50, 53, 91]
                },
            },
            labels: ['Average Results'],
        },
    };

    return (
        <div className="p-2">
            {userDetails.role === "superAdmin" && (
                <div className="d-flex justify-content-end align-items-center">
                    {
                        mode === 'view' ? '' : (<>
                            <div className="clickbtn" onClick={() => handlerUpdate(data._id)}>
                                <FiEdit className="text-secondary me-1" />
                            </div>
                            <div className="clickbtn" onClick={() => handlerRemove(data._id)}>
                                <MdDeleteForever className="fs-5 text-secondary" />
                            </div>
                        </>)
                    }
                </div>
            )}
            <div className="p-2">
                <h4 className="text-center fw-bold mb-0"> {data.title} </h4>
                <Chart
                    options={options.options}
                    series={options.series}
                    type="radialBar"
                />
            </div>
        </div>
    );
};

export default RedialChartLayout;